import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrack, BatteryWarning, Brain, TrendingUp } from 'lucide-react';
export function IdentificationSection() {
  const painPoints = [{
    icon: <TrendingUp size={24} className="text-accent-dark" data-id="element-92" />,
    text: 'Engordas aunque comas exactamente igual que hace 5 años'
  }, {
    icon: <BatteryWarning size={24} className="text-accent-dark" data-id="element-93" />,
    text: 'Te despiertas cansada, sin importar cuántas horas duermas'
  }, {
    icon: <HeartCrack size={24} className="text-accent-dark" data-id="element-94" />,
    text: 'Vives inflamada y sientes que tu ropa te aprieta de la nada'
  }, {
    icon: <Brain size={24} className="text-accent-dark" data-id="element-95" />,
    text: "Tienes 'niebla mental', olvidas cosas y te cuesta concentrarte"
  }];
  return <section className="py-20 px-4 bg-primary-contrast" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-98">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-text-primary mb-6" data-id="element-99">
            No estás loca. No es falta de disciplina.{' '}
            <span className="text-accent-dark italic" data-id="element-100">Y no estás sola.</span>
          </h2>
          <p className="text-lg sm:text-xl text-text-primary/80 leading-relaxed max-w-3xl mx-auto" data-id="element-101">
            Durante la peri-menopausia, el paisaje hormonal cambia
            drásticamente. Lo que antes funcionaba para mantenerte en forma y
            con energía, de repente deja de dar resultados. Muchas mujeres
            sienten que su propio cuerpo las ha traicionado.
          </p>
        </motion.div>

        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-xl border border-text-primary/5 relative overflow-hidden" data-id="element-102">
          {/* Decorative quote mark */}
          <div className="absolute -top-6 -left-4 text-9xl text-primary-contrast font-serif opacity-50 select-none pointer-events-none" data-id="element-103">
            "
          </div>

          <div className="relative z-10" data-id="element-104">
            <h3 className="text-xl sm:text-2xl font-bold text-text-primary mb-8 text-center" data-id="element-105">
              ¿Te suena familiar alguna de estas situaciones?
            </h3>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-106">
              {painPoints.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-4 p-4 rounded-2xl bg-primary-bg/50 hover:bg-primary-bg transition-colors" data-id="element-107">
                  <div className="mt-1 p-2 bg-white rounded-full shadow-sm" data-id="element-108">
                    {point.icon}
                  </div>
                  <p className="text-text-primary font-medium leading-snug" data-id="element-109">
                    {point.text}
                  </p>
                </motion.div>)}
            </div>

            <div className="mt-10 text-center" data-id="element-110">
              <p className="text-lg font-semibold text-text-primary/90 italic" data-id="element-111">
                "Siento que mi cuerpo dejó de responder..."
              </p>
              <p className="mt-2 text-text-primary/70" data-id="element-112">
                Es la frase que más escuchamos. Y tiene una explicación
                biológica real.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}